import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { useModal } from 'Components/Co2ModalService/ModalContext';
import { showNoDemoAccessModal } from 'Components/Co2Common/permissionModals';

const demoAccountData = createSelector(
    (state: any) => state.Co2Profile,
    (profileData) => ({
        isDemoAccount: !!profileData?.userBusiness?.demo_account,
    })
);

/**
 * Blocks restricted actions (billing/payment/license changes) for demo accounts.
 * Call `denyIfDemoAccount()` before opening the relevant modal/starting the action —
 * it shows the "not allowed in demo mode" message and returns true when blocked.
 */
export const useDemoAccountGuard = () => {
    const { showModal } = useModal();
    const { isDemoAccount } = useSelector(demoAccountData);

    const denyIfDemoAccount = (): boolean => {
        if (!isDemoAccount) return false;
        showNoDemoAccessModal(showModal);
        return true;
    };

    return { isDemoAccount, denyIfDemoAccount };
};
